export default "__VITE_ASSET__45cef2ca__"